import actions from './lidActions'
import state from './lidState'
import getters from './lidGetters'
import mutations from './lidMutations'

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
